/* the color comes from the place where the link is used */
.link {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    font-size: 0.95em;
    font-weight: 500;
    color: inherit;
    text-decoration: none;
    white-space: nowrap;
    transition: color 0.3s ease;
}

.text {
    position: relative;
}

.text::after {
    content: '';
    position: absolute;
    left: 0;
    bottom: -4px;
    width: 100%;
    height: 1px;
    background-color: currentColor;
    transform: scaleX(0);
    transform-origin: left;
    transition: transform 0.3s ease;
}

.link:hover .text::after, .link:focus-visible .text::after {
    transform: scaleX(1);
}

.icon {
    flex-shrink: 0;
    transition: transform 0.3s ease;
}

.link:hover .icon, .link:focus-visible .icon {
    transform: translateY(3px);
}

.format {
    padding: 2px 6px;
    border: 1px solid currentColor;
    border-radius: 3px;
    font-size: 0.65em;
    font-weight: 600;
    letter-spacing: 1px;
    opacity: 0.6;
}
